import { render, staticRenderFns } from "./WeeksGroupRanking.vue?vue&type=template&id=7a24d5a0&"
import script from "./WeeksGroupRanking.vue?vue&type=script&lang=js&"
export * from "./WeeksGroupRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports